import { useForm, type UseFormReturn } from 'react-hook-form';
import type { CreateCryptoAddressFormValues } from './types';
import { defaultValues } from './data';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { createCryptoAddressFormSchema } from './validation';

type Props = {
  initialValues?: Partial<CreateCryptoAddressFormValues>;
};

type Params = {
  form: UseFormReturn<CreateCryptoAddressFormValues>;
  selectedAssetCode: string;
};

export const useCreateCryptoAddressForm = ({
  initialValues,
}: Props): Params => {
  const { t } = useTranslation();

  const schema = createCryptoAddressFormSchema(t);

  const form = useForm<CreateCryptoAddressFormValues>({
    mode: 'onChange',
    resolver: zodResolver(schema),
    defaultValues: { ...defaultValues, ...initialValues },
  });

  const selectedAssetCode = form.watch('assetCode');

  return {
    form,
    selectedAssetCode,
  };
};
